import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Home from "./pages/home";
import Blogs from "./pages/Blogs";
import AIToolsPage from "./pages/AITools";
import BlogDetails from "./pages/BlogDetails";
import SubmitTool from "./pages/SubmitTool";
import CategoryDetail from "./pages/CategoryDetail";
import Auth from "./pages/Auth";
import Profile from "./pages/Profile";
import HowTos from "./pages/HowTos";
import HowToDetails from "./pages/HowToDetails";
import Tutorials from "./pages/Tutorials";

// Track route changes for Google Analytics SPA navigation
function RouteAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("config", "G-HVNLQ8ZZ88", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    let lastScrollY = window.scrollY || window.pageYOffset;
    
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      // Add class when scrolling down, remove when scrolling up
      if (scrollY > lastScrollY && scrollY > 80) {
        document.body.classList.add("scroll-down");
      } else {
        document.body.classList.remove("scroll-down");
      }
      lastScrollY = scrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (

    <BrowserRouter>
      <RouteAnalyticsTracker />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/tools" element={<AIToolsPage />} />
        <Route path="/submit" element={<SubmitTool />} />
        <Route path="/category/:categoryId" element={<CategoryDetail />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        <Route path="/signin" element={<Auth />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/how-tos" element={<HowTos />} />
        <Route path="/how-tos/:id" element={<HowToDetails />} />
        <Route path="/tutorials" element={<Tutorials />} />
      </Routes>

    </BrowserRouter>

  );
}

export default App;